<template>
    <section style="margin: 18px;">
        <v-btn @click="OpenAddFeatures">Add Features</v-btn>
        <app-add-features ref="GetCourseDetailsList" :dialog='AddFeatureDialog' @close='CloseDialog'></app-add-features>
        <app-feature-table></app-feature-table>
    </section>
</template>
<script>

import appAddFeatures from '../views/dialogs/AddFeatures'
import appFeatureTable from '../views/tables/FeaturesTable'

export default {
   components:{
       appAddFeatures,
       appFeatureTable
   },
   data(){
       return {
           AddFeatureDialog : false
       }
   },
   computed:{

   },
   methods:{
       OpenAddFeatures(){

           this.$refs.GetCourseDetailsList.GetCourseDetailsList()
           this.AddFeatureDialog = true
       },
       CloseDialog(){

           this.AddFeatureDialog = false
       }
   },
   mounted(){
       this.$eventHub.$emit("LOADING",'false')
   }
}
</script>
<style scoped>

</style>
